"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseReq = parseReq;
/** Matches a requirement handle: IN<n>, EX<n>, or C<n>. */
const REQ_ID = /^(IN|EX|C)\d+$/;
/**
 * Pure parser: extract the structured requirement lists from a req doc body.
 *
 * Heading-independent — items are bucketed by their inline-code ID prefix, so
 * section wording/emoji can drift without breaking the parse. A bullet whose
 * first token is not a `` `IN|EX|C<n>` `` handle is ignored (prose, notes).
 */
function parseReq(body) {
    const result = { included: [], excluded: [], constraints: [] };
    for (const line of body.split('\n')) {
        // A markdown bullet (- or *) whose first token is an inline-code handle.
        const m = line.match(/^\s*[-*]\s+`([^`]+)`\s*(.*)$/);
        if (!m)
            continue;
        const id = m[1].trim();
        if (!REQ_ID.test(id))
            continue;
        // An optional `~dropped` marker immediately after the handle retires the
        // item without deleting it; strip it from the human-readable text.
        let text = m[2].trim();
        let status = 'active';
        const drop = text.match(/^~dropped\b[ \t]*/i);
        if (drop) {
            status = 'dropped';
            text = text.slice(drop[0].length).trim();
        }
        const item = { id, text, status };
        if (id.startsWith('IN'))
            result.included.push(item);
        else if (id.startsWith('EX'))
            result.excluded.push(item);
        else
            result.constraints.push(item); // REQ_ID guarantees C<n> here
    }
    return result;
}
